<template>
  <div class="Footer">
    <div class="Footer-box centre">
      <ul class="Footer-ul">
        <li @click="booksBtn"><span style="padding-left: 0">|</span>在线书库</li>
        <li @click="aboutBtn"><span>|</span>关于我们</li>
        <li @click="helpBtn"><span>|</span>帮助文档<span>|</span></li>
        <!-- <li><span>|</span>技术支持<span>|</span></li> -->
      </ul>
      <div style="font-weight:bold">
        @版权所有：青岛市图书馆
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    aboutBtn() {
      this.$router.push('/about');
    },
    booksBtn() {
      this.$router.push('/library');
    },
    helpBtn() {
      window.open('/banner/help.pdf')
    }
  }
};
</script>

<style lang="less" scoped>
.Footer {
  height: 80px;
  background-color: #2c2c2c;
  color: #fff;
  .Footer-box {
    height: 80px;
    display: flex;
    align-items: center;
    font-size: 18px;
    letter-spacing: 2px;
    margin: auto;
    justify-content: space-between;
    .Footer-ul {
      display: flex;
      li {
        cursor: pointer;
        font-weight: bold;
        span {
          padding:0 40px;
        }
      }
    }
  }
}
</style>
